import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../pages/onboarding/onboarding.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!key) { setError('Enter admin key'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ admin_key: key }),
      });
      const result = await res.json();
      if (result.success) {
        localStorage.setItem('cia_admin_token', result.token);
        navigate('/admin/dashboard');
      } else {
        setError(result.error || 'Invalid admin key');
      }
    } catch (e) {
      setError('Connection failed');
    }
    setLoading(false);
  };

  return (
    <div className="ob-container">
      <header className="ob-header">
        <div className="ob-logo">
          <div className="ob-logo-icon">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="11" stroke="#00C896" strokeWidth="2.4"/>
              <circle cx="14" cy="14" r="4" fill="#00C896"/>
              <path d="M19 18.5L21.2 20.7L25.5 15.5" stroke="#3B82F6" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span className="ob-logo-text">Aizaan Admin</span>
        </div>
      </header>
      <div className="ob-body">
        <div className="ob-card">
          <h1 className="ob-title">Admin Access</h1>
          <p className="ob-subtitle">Enter your admin key to continue</p>
          <div className="ob-field">
            <label className="ob-label">Admin Key</label>
            <input
              className="ob-input"
              type="password"
              placeholder="Enter admin key"
              value={key}
              onChange={e => { setKey(e.target.value); setError(''); }}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              autoFocus
            />
          </div>
          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 8, padding: '10px 14px', marginBottom: 16,
              fontSize: 13, color: 'var(--red)',
            }}>{error}</div>
          )}
          <button className="ob-btn ob-btn-primary" onClick={handleLogin} disabled={loading}>
            {loading ? 'Verifying...' : 'Access Admin Panel →'}
          </button>
        </div>
      </div>
    </div>
  );
}
